import imageOne from '@/assets/images/cities/edmonton1.jpg'
import imageTwo from '@/assets/images/cities/edmonton2.jpg'
import imageThree from '@/assets/images/cities/edmonton3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Edmonton',
  writeup: '',
  website: 'EdmontonNotaryPublic.com',
  url: 'https://www.edmontonnotarypublic.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '(780) 758-8475',
      hours: {
        monday: '9:00AM to 5:00PM',
        tuesday: '9:00AM to 5:00PM',
        wednesday: '9:00AM to 5:00PM',
        thursday: '9:00AM to 5:00PM',
        friday: '9:00AM to 3:30PM',
        saturday: '10:00AM to 2:00PM',
        sunday: 'Closed'
      },
      address: '10714 124 Street Location',
      notes: 'No Power of Attorneys.'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/alberta/cities/edmonton.js